import { BASE_URL } from '../url';

// eslint-disable-next-line import/prefer-default-export
export const PUBLIC_IP_ALLOCATIONS_URL = `${BASE_URL}/Ipallocation/public`;
